<template>
    <div class="hstack gap-2 align-self-end">
        <label class="b-table-header-info" v-if="options.totalItemCount >= 0">
            {{itemStart}}-{{itemEnd}} of {{options.totalItemCount}}
        </label>
        <select class="form-select b-table-header-pagesize py-1 border border-dark" aria-label="Select Page Size" v-model.number="value.itemsPerPage" @change="setItemsPerPage" placeholder="Select an agency">
            <option v-for="option in itemsPerPageOptions"
                    :value="option.value">
                {{ option.text }}
            </option>
        </select>
            <button type="button" :class="'btn btn-sm ' + (canGo(-1)?'border border-dark':'')"
                    @click.prevent="first()"
                    :disabled="!canGoPrevious"
                    data-bs-toggle="tooltip"
                    data-bs-title="First Page">
                <i class="bi bi-chevron-double-left"></i>
            </button>
            <button type="button" :class="'btn btn-sm ' + (canGo(-1)?'border border-dark':'')"
                    @click.prevent="go(-1)"
                    :disabled="!canGoPrevious"
                    data-bs-toggle="tooltip"
                    data-bs-title="Previous Page">
                <i class="bi bi-chevron-left"></i>
            </button>
            <button type="button" :class="'btn btn-sm ' + (canGo(+1)?'border border-dark':'')"
                    @click.prevent="go(+1)"
                    :disabled="!canGoNext"
                    data-bs-toggle="tooltip"
                    data-bs-title="Next Page">
                <i class="bi bi-chevron-right"></i>
            </button>
            <button type="button" :class="'btn btn-sm ' + (canGo(+1)?'border border-dark':'')"
                    @click.prevent="last()"
                    :disabled="!canGoNext"
                    data-bs-toggle="tooltip"
                    data-bs-title="Last Page">
                <i class="bi bi-chevron-double-right"></i>
            </button>
    </div>
</template>
<script setup lang="ts">
import { computed, ref, defineProps, watch } from 'vue';
import { BTableOptions, BSelectOptionsNumber } from "@/components/BTable/BTable.types";

const emits = defineEmits(['optionChange']);

const props = withDefaults(defineProps<{
    value: BTableOptions,
    headerSlotClass?: string
    }>(), {
    headerSlotClass: ''
    });    
    
    var options = ref(props.value as BTableOptions);    
    
    const itemsPerPageOptions = [
        { text: "25", value: 25 },
        { text: "50", value: 50 },
        { text: "100", value: 100 }
        ] as BSelectOptionsNumber[];    

    var maxPage = computed((): number => {
        return Math.ceil(options.value.totalItemCount / options.value.itemsPerPage);
    });

    var itemStart = computed((): number => {
        return Math.min(
            options.value.totalItemCount,
            (options.value.page - 1) * options.value.itemsPerPage + 1
        );
    });
    
    var itemEnd = computed((): number => {
        return Math.min(
            options.value.totalItemCount,
            options.value.page * options.value.itemsPerPage
        );
    });

    var canGoNext = computed((): boolean => {
        return canGo(+1);
    });

    var canGoPrevious = computed((): boolean => {
        return canGo(-1);
    });

    function first() {
        goToPage(1);
    }

    function last() {
        goToPage(maxPage.value);
    }

    function goToPage(pageNumber: number) {       
        options.value.page = pageNumber;
        emits("optionChange", options.value);
    }
    
    function go(deltaPage: number) {
        goToPage(Math.max(1, Math.min(maxPage.value, options.value.page + deltaPage)));
    }
    
    function canGo(deltaPage: number) {
        var newPage = options.value.page + deltaPage;
        return newPage >= 1 && newPage <= maxPage.value;
    }
    
    function setItemsPerPage(e:any) { 
        options.value.itemsPerPage = options.value.itemsPerPage;
        options.value.page = 1;
        emits("optionChange", options.value);
    }
</script>